import React from 'react';
import { concatStyles } from 'utils';
var PARA_STYLES = 'text-md py-2';
export var Para = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("p", { className: concatStyles(PARA_STYLES, className) }, children));
};
